import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { PlatformService } from '../platform/platform.service';

@Injectable({
  providedIn: 'root'
})
export class PreventScrollService {
  private renderer: Renderer2;
  public scrollY = 0;

  constructor(private platformService: PlatformService, private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /**
   * Add a class to prevent scroll on mobile
   */
  preventScrollOnBody(): void {
    if (this.platformService.isBrowser) {
      this.scrollY = (window as any).scrollY;
      this.renderer.addClass(document.body, 'safariNoScroll');
    }
  }

  /**
   * Remove class preventing scroll on body and
   * capture the scroll position
   */
  allowScrollOnBody(): void {
    if (this.platformService.isBrowser) {
      this.renderer.removeClass(document.body, 'safariNoScroll');
      (window as any).scrollTo(0, this.scrollY);
    }
  }
}
